import {
  PayableTypeSchema,
  type PayableType as GeneratedPayableType
} from '~/services/api/generated'

// Mirrors backend App\Enums\Payment\PayableType

export type PayableType = GeneratedPayableType

export const PayableType = {
  STORES: PayableTypeSchema.enum.stores,
  PARTNERS: PayableTypeSchema.enum.partners,
  BRANDS: PayableTypeSchema.enum.brands
} satisfies Record<string, GeneratedPayableType>

export const PayableTypeValues: readonly GeneratedPayableType[] = [
  PayableTypeSchema.enum.stores,
  PayableTypeSchema.enum.partners,
  PayableTypeSchema.enum.brands
]
